import {Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SharedService }   from '../shared/shared/shared.service';

import { AccountService } from '../security/shared/account.service';

@Component({
    selector: 'home',
    templateUrl: './home.component.html'

})

export class HomeComponent implements OnInit {

    userRole!: string ;
    @ViewChild('btnhideBars')
    btnhideBars!: ElementRef;

    public constructor(
        private _route: ActivatedRoute,
        public accountService: AccountService,
         public translate: TranslateService,
       public SharedService:SharedService) {
            this.translate.get("document.HomePage").subscribe(name=>{
                this.SharedService.setTitle(name);
              });
         }


    ngOnInit(): void {
        this.userRole = this._route.snapshot.params['role'];
        
        //this.accountService.changeUserRole(this.userRole);

        this.btnhideBars.nativeElement.click();
    }

}